import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Zap, TrendingDown, Brain, Network, Sparkles, ShieldCheck } from "lucide-react";

const ICONS = [Zap, TrendingDown, Brain, Network, Sparkles, ShieldCheck];

export const WhyBicenter = () => {
  const { t } = useLanguage();

  return (
    <section id="why" className="relative py-28 md:py-36" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.4em] text-bicenter-cyan font-mono">
              {t.why.kicker}
            </p>
            <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-white leading-[1.05]">
              {t.why.title}
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-8">
            <p className="text-lg md:text-xl text-zinc-400 font-body leading-relaxed">
              {t.why.subtitle}
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/10 rounded-3xl overflow-hidden">
          {t.why.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                data-testid={`why-item-${i}`}
                className="group relative bg-[#0c0c0e] p-8 lg:p-10 hover:bg-[#0f0f12] transition-colors duration-500 min-h-[260px] flex flex-col justify-between"
              >
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-bicenter-cyan/10 to-bicenter-violet/10 border border-white/10 flex items-center justify-center group-hover:border-bicenter-cyan/40 transition-all">
                  <Icon size={20} className="text-bicenter-cyan group-hover:text-white transition-colors" />
                </div>
                <div className="mt-8">
                  <h3 className="font-display text-2xl text-white font-medium mb-3">{item.t}</h3>
                  <p className="text-sm text-zinc-400 leading-relaxed">{item.d}</p>
                </div>
                <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-bicenter-cyan/0 to-transparent group-hover:via-bicenter-cyan/60 transition-all duration-500"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
